<template>
  <!-- 2021/11/19  #12251  START -->
  <section class="Security__alert0008">
    <section class="error__text__modal0009">
      <div class="outer__div" v-if=getdialogVisible>
          <div class="inner__modal">
              <div class="modal__message">
                  <p>{{getdialogVisible}}</p>
                  <el-button type="info" plain class="float__right" @click="closeTab">閉じる</el-button>
              </div>
          </div>
      </div>
    </section>
    <div class="outer__block"  v-if="!getdialogVisible">
    <!-- 2021/11/19  #12251  END -->
      <el-row :gutter="0" class="Article__display__confirmationHead">
        <router-link to="/sp/0002" class="Router__To__Destination" tabindex="1">
          <i class="el-icon-close" tabindex="1"></i>
        </router-link>
        <el-col :span="6" class="whiteBg">
          <span class="Article__display__confirmationSpan">記事表示確認</span>
        </el-col>
        <el-col :span="12">
          <img src="../../../assets/image/logo-new.png" alt="logo" class="ElnetLogo" />
        </el-col>
        <el-col :span="6"></el-col>
      </el-row>
      <el-row class="Article__display__confirmationBody">
        <p>{{AlertMessage}}</p>
        <p v-if="articleListDisplayFlag">原文表示不可記事一覧</p>
        <template v-if="articleListDisplayFlag">
          <el-tabs type="card" class="news__tab">
            <el-tab-pane :label=CounterLabel class="news__tab__pane" >
            <div v-for="articleInfo in errorArticles" v-bind:key="articleInfo">

              <div class="news__tabpane__article" >
                  <el-row class="news__tabpane__row">
                      <div class="news__tabpane__article__id">
                          {{articleInfo.article_id}}
                      </div>
                      <div class="news__tabpane__article__headline">
                          <p>{{articleInfo.article_title}}</p>
                      </div>
                  </el-row>
                  <el-row class="news__tabpane__row">
                      <div class="news__tabpane__article__company">
                          <img :src=articleInfo.articleImage alt="logo" />
                      </div>
                      <div class="news__tabpane__article__info">
                          <span>●{{articleInfo.media_name}}</span>
                          <span>●{{articleInfo.issue_date}}</span>
                          <span>●{{articleInfo.issue_type}}</span>
                          <span>●{{articleInfo.search_word}}</span>
                      </div>
                  </el-row>
                  <!-- <el-row class="news__tabpane__row">
                      <div class="news__tabpane__article__format">
                          <div class="PdfFormat"></div>
                          <div class="DocFormat"></div>
                          <div class="TextFormat"></div>
                          <div class="PrintFormat"></div>
                      </div>
                  </el-row> -->
              </div>
              <div class="news__tabpane__comment">
                  <el-row class="comment__row" v-if="articleInfo.article_comment != null && articleInfo.article_comment != ''">
                      <div class="comment__icon"></div>
                      <div>
                        <span class="comment__span">{{articleInfo.article_comment}}</span>
                      </div>
                  </el-row>
              </div>
              <span class="divider__row"></span>       
            </div>
            
            </el-tab-pane>
          </el-tabs>
        </template>
        <p v-if="displayButton">原文表示可能な記事で表示する場合には、表示ボタンを押してください。</p>
        <p>もう一度記事選択に戻る場合には、閉じるボタンを押してください。</p>
        <el-row class="Article__display__buttongroup">
          <el-button type="info" @click="goToPdfScreen" v-loading.fullscreen.lock="fullscreenLoading" v-if="displayButton" plain>表示</el-button>
          <el-button type="info" @click="closeTab" plain>閉じる</el-button>
        </el-row>
      </el-row>
    <!-- 2021/11/19  #12251  START -->
    </div>
    <!-- 2021/11/19  #12251  END -->
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import router from '../../../router';
//import Common from '../../../common/CommonFunc.js'
import Vue from "vue";
export default {
  name: "Article__display__confirmation0004",
  props: [],
  data() {
    return {
      errorArticles:  Vue.prototype.$session.get('NewsArticles'),
      displayButton: Vue.prototype.$session.get('displayButton'),
      CounterLabel: Vue.prototype.$session.get('CounterLabel'),
      AlertMessage: Vue.prototype.$session.get('AlertMessage'),
      articleListDisplayFlag: Vue.prototype.$session.get('articleListDisplayFlag'),
      userId: '',
      contract_code: '',
      theme_browsing: '',
      fullscreenLoading: false
    };
  },
  methods: {
    closeTab(){
      this.$LogButtonEvent("0004","Close");
      this.$LogMethodIN("0004","closeTab");   
      var mailFlag = Vue.prototype.$session.get('mailFlagForCloseButton')
      console.log(mailFlag)
      if(mailFlag)
      {
        router.push('/sp/0002');
      }
      else
      {
        window.close();
      }     
      this.$LogMethodOut("0004","closeTab");
    },
    goToPdfScreen(){
      this.$LogButtonEvent("0004","MeansPdf");
      this.$LogMethodIN("0004","goToPdfScreen");
      var pdfConvertValues = Vue.prototype.$session.get('pdfConvertValues');
      var pdfCompletionArray = Vue.prototype.$session.get('pdfSuccessArray')
      console.log(pdfConvertValues)
      var pdfValues = {
          pdf_flag:1,
          article_info:pdfConvertValues,
          user_id:this.userId,
          contract_code:this.contract_code,
          theme_browsing:this.theme_browsing,
          display_id:"SID0002",
          // 2022/08/03  #13204  START
          is_from0004:true,
          // 2022/08/03  #13204  END
          is_mail:false,
      };
      console.log(pdfValues);

      var pdfSuccessArray = {
          data_info: pdfCompletionArray
      };

      var pdfCombinedArray = [];

      pdfCombinedArray = [...pdfCombinedArray, pdfValues, pdfSuccessArray];
      /*******BT08460_EXTERNAL-1225 issue fix*******/
      this.$session.set('pdfCombinedArray', pdfCombinedArray);
      let routeData = this.$router.resolve({name: '0001-001'}); 
      window.open(routeData.href, '_blank');
      /*this.fullscreenLoading = true;
      this.$store.dispatch('sp_Communication0004/checkPdfDisplay', pdfCombinedArray).then(() => {
        this.fullscreenLoading = false;
        // if(this.getPopUpBlockerFlag == true)
        // {
        //   this.$store.commit('sp_Situation0001/setPopUpBlockerFlag', false, { root: true });
        //   this.$confirm("このサイトではポップアップウインドウが有効になっています。サイトを除外リストに追加してください。","更新",
        //   {
        //     showCancelButton: true,
        //     confirmButtonText: "OK",
        //     cancelButtonText: "キャンセル",
        //     beforeClose: (action, instance, done) => {
        //       if(action === "confirm"){
        //         done();
        //       }else{
        //         done();
        //       }
        //     }
        //   });
        // }
      }).catch(() => {
        this.fullscreenLoading = false;
      })*/
      this.$LogMethodOut("0004","goToPdfScreen");
    }
  },
  
  computed: {
    // 2021/11/19  #12251  START
    //...mapGetters("sp_Situation0004", ["getPdfName","getNewsArticles","getDemandMaxCountAlert"]),
    ...mapGetters("sp_Situation0004", ["getPdfName","getNewsArticles","getdialogVisible","getDemandMaxCountAlert"]),
    // 2021/11/19  #12251  END
    ...mapGetters("sp_Situation0001", ["getPopUpBlockerFlag"]),
    ...mapGetters("situation0001", [
        "getUserId",
        "getContractCode",
        "getThemeBrowsing"

    ])
  },
  mounted() {
    //get the user id value from session
    this.userId = this.getUserId

    //get the contract code value from session
    this.contract_code = this.getContractCode

    //get the theme_browsing value from session
    this.theme_browsing = this.getThemeBrowsing

    /*** Change by SJ for backlog Id: 1598 */
    if (this.getDemandMaxCountAlert !='') {
            this.$alert(this.getDemandMaxCountAlert, "確認", {
                confirmButtonText: "OK",
            });
        }
        else{
            console.log("No action ")
        }
  },
  beforeCreate(){
      // Common.Session.SP_CheckSessionExists_IfExpired_GoToLogout();
      //Common.Session.CheckIsMobile("/sp/0004","/0004"); // MobileScreen Path, WebScreen Path
 }
};
</script>

<style scoped>
@import "0004.css";
@import "../../0009/0009.css";
@import  "../../../assets/css/customStyle.css";
</style>